import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error-pago-inicio',
  templateUrl: './error-pago-inicio.component.html',
  styleUrls: ['./error-pago-inicio.component.scss']
})
export class ErrorPagoInicioComponent implements OnInit {

  telefonos = environment.telefonos;
  emails = environment.emails;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  Regresar() {
    this.router.navigate(['/']);
  }

}
